import { render, staticRenderFns } from "./WsDemoExamsCardList.vue?vue&type=template&id=0456563e&class=ws-demo-exams__item"
import script from "./WsDemoExamsCardList.vue?vue&type=script&lang=js"
export * from "./WsDemoExamsCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports